export class BasketDeliveryAddress {
    id?: string;
    building?: string;
    streetaddress: string;
    city: string;
    zipcode: string;
    phonenumber?: string;
    specialinstructions?: string;
    isdefault?: boolean;
    firstName?: string;
    lastName?: string;
    suite?: string;
    latitude: number;
    longitude: number;
    streetLabel?: string;
    state?: string;

    public static Make(
        addressSearched: string,
        addressDetails: {
            number: string;
            street: string;
            city: string;
            postalCode: string;
            lat: number;
            long: number;
            streetLabel: string;
            state?: string;
        },
        building?: string
    ): BasketDeliveryAddress {
        const basketDeliveryAddress = {
            streetaddress: addressSearched,
            building: building,
            city: addressDetails.city,
            zipcode: addressDetails.postalCode,
            latitude: addressDetails.lat,
            longitude: addressDetails.long,
            streetLabel: addressDetails.streetLabel,
            state: addressDetails.state,
        };
        return basketDeliveryAddress;
    }
}
